import styled from '@emotion/styled';
import { AlumniSansFont, RobotoFont } from '../../../styles/fonts';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 119px;
  padding-top: 22px;

  .submitted-header {
    font-family: ${AlumniSansFont.style.fontFamily}, sans-serif;
    font-style: normal;
    font-weight: 450;
    font-size: 36px;
    line-height: 44px;
    color: #181818;
    @media screen and (max-width: 600px) {
      font-size: 28px;
      text-align: center;
    }
  }

  .submitted-info {
    font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #535353;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 4px;
    transform: rotate(-0.28deg);
    letter-spacing: -0.57px;
  }

  .close-icon {
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .button-styled {
    min-width: 150px;
    max-width: 200px;
    width: 100%;
  }

  .buttons {
    display: flex;
    gap: 12px;
    margin-top: 24px;
  }
`;

export const modalStyle = {
  position: 'absolute' as 'absolute',
  padding: '48px 60px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: '216px',
  maxHeight: '85vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '2px',
  outline: 'none',
  width: 418,
  '@media screen and (max-width: 600px)': {
    width: '80%',
    height: 'auto',
    padding: '20px',
  },
  '::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '::-webkit-scrollbar-track': {
    borderRadius: '5px',
    backgroundColor: '#ffffff',
  },
  '::-webkit-scrollbar-thumb': {
    borderRadius: '5px',
    backgroundColor: '#ffffff',
  },
};
